export default {
  "slots": {
    "base": "text-4xl text-(--ui-text-highlighted) font-bold mb-8 scroll-mt-[calc(45px+var(--ui-header-height))] lg:scroll-mt-(--ui-header-height)",
    "link": "inline-flex items-center gap-2"
  }
}